import { FC, useState,useEffect } from 'react'
import { Layout } from '../../../containers'
import './style.scss'
import AgendaStep2Examenes from "./steps/examenes-step2";
import AgendaStep4Examenes from "./steps/examenes-step4";
import AgendaStep5Questions from "./steps/examenes-step5";
import AgendaStep6Examenes from "./steps/examenes-step6";
import AgendaStep7Examenes from "./steps/examenes-step7";


const SchedulePage:FC = () => {

    interface StepData {
        StepTwoExamenes: string;
        StepFourthExamenes: {
            examenName: string;
            questions: string[];
        };
        StepFiveExamenes?: string;
        StepSixExamenes?: string;
        currentStep?: string;
    }

    const [stepData, setStepData] = useState<StepData>({
        StepTwoExamenes: '',
        StepFourthExamenes: {
            examenName: '',
            questions: []
        },
        StepFiveExamenes: '',
        StepSixExamenes: '',
        currentStep: ''
    });

    const [stepFourthExamenes, setStepFourthExamenes] = useState(''); //Seleccione Parte del cuerpo
    const [stepFiveExamenes, setStepFiveExamenes] = useState('');
    const [stepSixExamenes, setStepSixExamenes] = useState('');

    const handleStepData = (value : any) => {
        console.log('value', value);
        setStepData({
            ...stepData,
            ...value
        });
    };

    const [currentStep, setCurrentStep] = useState('0');

    const [stepTwoExamenes, setStepTwoExamenes] = useState('');
    const handleCurrentStep = (value: string ) => {
        setCurrentStep(value);
        handleStepData({'currentStep': value});
    };

    const handleStepTwoExamenes = (value: string) => { setStepTwoExamenes(value); handleStepData({'StepTwoExamenes': value}) };
    const handleStepFourthExamenes = (value: any) => {
        console.log('handleStepFourthExamenes value', value);
        setStepFourthExamenes(value); handleStepData({'StepFourthExamenes': value});
    };
    const handleStepFiveExamenes = (value: any) => { setStepFiveExamenes(value); handleStepData({'StepFiveExamenes': value}) };

    const handleStepSixExamenes = (value: any) => { setStepSixExamenes(value); handleStepData({'StepSixExamenes': value}) };

    const setStep = (event : any) => {
        setStepValue(event.target.value);
        setSelectedOption(event.target.value);
        setCanContinue(true);
    };

    const [stepValue, setStepValue] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const [canContinue, setCanContinue] = useState(false);

    return (
        <Layout menu titleMain={5}>
            { (currentStep === "0" || currentStep === "examenes") && <AgendaStep2Examenes setCurrentStep={handleCurrentStep} setStepValue={handleStepTwoExamenes}></AgendaStep2Examenes> }
            { (currentStep === "maipu_examenes"  || currentStep === "providencia_examenes" ||  currentStep === "imagenologia" || currentStep === "laboratorio" || currentStep === "vacunatorio" || currentStep === "banco_sangre") && (
                <>
                    <AgendaStep4Examenes setCurrentStep={handleCurrentStep} setStepValue={handleStepFourthExamenes} stepData={stepData}></AgendaStep4Examenes>
                </>
            )}
            { currentStep === "questions" && <AgendaStep5Questions setCurrentStep={handleCurrentStep} setStepValue={handleStepFiveExamenes} stepData={stepData}></AgendaStep5Questions> }
            { currentStep === "solicitar-contacto" && <AgendaStep6Examenes setCurrentStep={handleCurrentStep} setStepValue={handleStepSixExamenes} stepData={stepData}></AgendaStep6Examenes> }
            { currentStep === "thank-you-page" && <AgendaStep7Examenes></AgendaStep7Examenes> }
        </Layout>
    )
}

export {
    SchedulePage
}
